import React from 'react';
import PageTemplate from '../../../components/template/PageTemplate';
import RemoteImageReferralDetailContainer from '../../../containers/remoteImage/referral/RemoteImageReferralDetailContainer';
import {
  REMOTE_REFERRAL_IMAGE_PAGE_NAME,
  REMOTE_IMAGE_DETAIL_PAGE_TYPE,
} from '../../../constants/service/app/remoteImageConstants';

const RemoteImageReferralEdit = () => {
  return (
    <PageTemplate pageName={REMOTE_REFERRAL_IMAGE_PAGE_NAME.REMOTE_REFERRAL_IMAGE_EDIT}>
      <RemoteImageReferralDetailContainer detailPageType={REMOTE_IMAGE_DETAIL_PAGE_TYPE.EDIT} />
    </PageTemplate>
  );
};

export default RemoteImageReferralEdit;
